import { Container, SpinnerContainer } from './styles';

export default function LoadingComponent() {
  return (
    <Container>
      <SpinnerContainer />
    </Container>
  );
}
